import React from "react"

import { useTranslation } from "react-i18next"

interface UserInfoHeaderProps {
  username: string
  userId: string
  bonusCount: number
}

export const UserInfoHeader: React.FC<UserInfoHeaderProps> = ({ username, userId, bonusCount }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  return (
    <div className="bg-[#0C0C1A] border border-emerald-600 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm text-gray-400">{t("bonus2.shared.viewingBonusesFor")}</div>
          <div className="text-white font-semibold text-lg mt-1">{username}</div>
          <div className="text-xs text-gray-500 font-mono mt-1">ID: {userId}</div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-purple-400">{bonusCount}</div>
          <div className="text-xs text-gray-400">{t("bonus2.shared.totalBonuses")}</div>
        </div>
      </div>
    </div>
  )
}
